import React from 'react';
import { withMedicamentContext } from 'components/medicaments/MedicamentsContext';
import MedicamentsSelectionView from 'components/medicaments/MedicamentsSelectionView';
import DosagesView from 'components/medicaments/dosages/DosagesView';
import VatGroupsView from 'components/medicaments/VatGroupsView';
import { SectionPage } from 'components/section/SectionPage';
import SectionContainer from 'components/section/SectionContainer';
import MedicamentsView from 'components/medicaments/MedicamentsView';
import MedicamentsUpdateView from 'components/medicaments/MedicamentsUpdateView';
import ArticleGroupsView from 'components/medicaments/ArticleGroupsView';
import TestLaboratoryView from 'components/medicaments/testlaboratiry/TestLaboratoryView';
import StockOrdersView from 'components/medicaments/stockorder/StockOrdersView';
import StockDataView from 'components/medicaments/stockdata/StockDataView';
import { Privilege } from 'ts-types/api.enums';
import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import CovidTestAnalyzerView from 'components/medicaments/covid-test-analyzer/CovidTestAnalyzerView';
import StockAdministrationView from 'components/medicaments/stockaadministration/StockAdministrationView';
import OrderAdministrationView from 'components/medicaments/orderadministration/OrderAdministrationView';
import MiGelImportView from 'components/medicaments/migel-import/MiGelImportView';

interface Props extends AuthConsumerRenderProps {

}

const MedicamentsHome = (props: Props) => {
  const pages: SectionPage[] = [
    {id: "medicaments", uri: "/medicaments", component: MedicamentsView},
    {id: "medicamentsSelection", uri: "/medicaments/selection", component: MedicamentsSelectionView},
    {id: "medicamentsUpdate", uri: "/medicaments/update", component: MedicamentsUpdateView},
    {id: "miGelImport", uri: "/medicaments/migel-import", component: MiGelImportView},
    {id: "dosage", uri: "/medicaments/dosage", component: DosagesView},
    {id: "vat", uri: "/medicaments/vat", component: VatGroupsView},
    {id: "testLaboratory", uri: "/medicaments/test-laboratory", component: TestLaboratoryView},
    {id: "covidTestAnalyzer", uri: "/medicaments/covid-test-analyzers", component: CovidTestAnalyzerView},
    {id: "articleGroup", uri:"/medicaments/article-groups", component: ArticleGroupsView},
  ];

  const stockManagementEnabled = props.currentUserHasPrivilege(Privilege.PX_CORE_STOCK_MANAGEMENT);

  if (stockManagementEnabled) {
    pages.push({id: "stockOrder", uri:"/medicaments/stock-orders", component: StockOrdersView});
    pages.push({id: "stockData", uri:"/medicaments/stock-data", component: StockDataView});
    pages.push({id: "stockAdministration", uri:"/medicaments/stock-administration", component: StockAdministrationView});
    pages.push({id: "orderAdministration", uri:"/medicaments/order-administration", component: OrderAdministrationView});
  }

  return (
      <SectionContainer sectionPages={pages}/>
  );
};

export default withAuthContext(withMedicamentContext(MedicamentsHome));
